import React from 'react';
import { Typography, Row, Col, Card, Space, Divider } from 'antd';

const { Title, Paragraph, Text } = Typography;

const AboutUs: React.FC = () => {
  return (
    <div className='container mx-auto py-12 px-4'>
      <Title level={2} className='text-center mb-8'>
        About Fruit Shop
      </Title>

      <div className='mb-8'>
        <Paragraph>
          Welcome to Fruit Shop, your premier destination for the freshest and
          highest quality fruits. Established in 2015, we have been committed to
          delivering nature's goodness directly to your doorstep.
        </Paragraph>

        <Paragraph>
          Our mission is simple: to provide our customers with access to
          farm-fresh fruits while supporting sustainable and ethical farming
          practices. We work directly with local farmers and trusted suppliers
          to ensure that every fruit in our inventory meets our strict quality
          standards.
        </Paragraph>
      </div>

      <Row gutter={[24, 24]} className='mb-8'>
        <Col xs={24} md={12}>
          <Card title='Our Values' className='h-full'>
            <Space direction='vertical' className='w-full'>
              <Paragraph>
                <Text strong>• Quality:</Text> We never compromise on the
                quality of our fruits.
              </Paragraph>
              <Paragraph>
                <Text strong>• Sustainability:</Text> We support environmentally
                responsible farming practices.
              </Paragraph>
              <Paragraph>
                <Text strong>• Community:</Text> We believe in building strong
                relationships with local farmers and our customers.
              </Paragraph>
              <Paragraph>
                <Text strong>• Innovation:</Text> We continuously improve our
                services to enhance your shopping experience.
              </Paragraph>
            </Space>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card title='Why Choose Us?' className='h-full'>
            <Space direction='vertical' className='w-full'>
              <Paragraph>
                <Text strong>• Freshness Guaranteed:</Text> Our fruits are
                carefully selected and delivered at peak freshness.
              </Paragraph>
              <Paragraph>
                <Text strong>• Wide Selection:</Text> From local favorites to
                exotic specialties, we offer a diverse range of fruits.
              </Paragraph>
              <Paragraph>
                <Text strong>• Convenient Delivery:</Text> We offer fast and
                reliable delivery services.
              </Paragraph>
              <Paragraph>
                <Text strong>• Customer Satisfaction:</Text> Your satisfaction
                is our top priority, backed by our excellent customer service.
              </Paragraph>
            </Space>
          </Card>
        </Col>
      </Row>

      <div className='mb-8'>
        <Title level={3}>Our Story</Title>
        <Paragraph>
          Fruit Shop began with a simple idea: to bring the farmers' market
          experience online. Our founder, a passionate advocate for healthy
          eating, noticed a gap in the market for high-quality, fresh fruits
          that were conveniently available. What started as a small operation
          has now grown into a trusted name in the community.
        </Paragraph>
        <Paragraph>
          Today, we're proud to serve thousands of customers who trust us for
          their fruit needs. Whether you're looking for everyday essentials or
          seasonal specialties, we're here to provide you with the best nature
          has to offer.
        </Paragraph>
      </div>
    </div>
  );
};

export default AboutUs;
